var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.97,
    height: 19.984,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23210"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15244",
    d: "m6.992 15.681-3 1.63a2.62 2.62 0 0 0-.48.34 10 10 0 0 0 12.84 0 3.15 3.15 0 0 0-.52-.35l-3.2-1.6a1.22 1.22 0 0 1-.64-1.06v-1.25c.09-.1.19-.24.3-.39a7.32 7.32 0 0 0 1-2 1 1 0 0 0 .7-1v-1.29a1 1 0 0 0-.32-.71v-2s.4-3-3.68-3-3.68 3-3.68 3v2a1 1 0 0 0-.32.71v1.29a1 1 0 0 0 .46.85 6.59 6.59 0 0 0 1.21 2.5v1.22a1.22 1.22 0 0 1-.67 1.11Z",
    fill: "#f5f6f8"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15245",
    d: "M10.162.001a10 10 0 0 0-6.6 17.65 2.25 2.25 0 0 1 .43-.34l3-1.63a1.22 1.22 0 0 0 .64-1.07v-1.22a6.59 6.59 0 0 1-1.21-2.51 1 1 0 0 1-.43-.88v-1.3a1 1 0 0 1 .32-.7v-2s-.4-3 3.68-3 3.68 3 3.68 3v2a1 1 0 0 1 .32.7v1.3a1 1 0 0 1-.71 1 7.62 7.62 0 0 1-1 2c-.11.15-.21.29-.3.39v1.25a1.22 1.22 0 0 0 .67 1.09l3.2 1.6a3.15 3.15 0 0 1 .52.35 10 10 0 0 0-6.21-17.68Z",
    fill: "#c3cbd7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePic);
export default __webpack_public_path__ + "static/media/Profile_Pic.a044b887c265b0ca18c15de338da9e14.svg";
export { ForwardRef as ReactComponent };